import ServiceAwardsService from './service-awards';
import CmxService from './cmx';

const serviceAwardsService = new ServiceAwardsService();
const cmxService = new CmxService();

export {
    serviceAwardsService,
    cmxService
};